import type React from 'react';

import { Button } from '@change/ds-core-ui/Button';
import { LockOutlineIcon } from '@change/ds-icons/LockOutlineIcon';

import { useSubmitButton } from './hooks/useSubmitButton';

type Props = {
	disabled: boolean;
	loading: boolean;
	onClick?: () => void;
};

export const SubmitButton: React.FC<Props> = ({ disabled, loading, onClick }) => {
	const { label } = useSubmitButton({ loading });
	return (
		<div className="w-full">
			<Button
				variant="primary"
				type="submit"
				className="w-full py-3"
				disabled={disabled || loading}
				data-qa="promote-submit-button"
				onClick={onClick}
				leadingIcon={<LockOutlineIcon size="x-small" />}
			>
				{label}
			</Button>
		</div>
	);
};
